import { useStaticQuery, graphql } from "gatsby";

export const UseAnnouncementBarMessages = () => {
  const data = useStaticQuery(graphql`
    query allAnnouncementBarMessages {
      AnnouncementBarMessages: allContentfulAnnouncementBarMessages(
        sort: { orderNumber: ASC }
      ) {
        nodes {
          title
          description {
            description
          }
          buttonText
          buttonLink
        }
      }
    }
  `);
  return data.AnnouncementBarMessages.nodes;
};
